import { motion, type HTMLMotionProps } from "framer-motion";
import { type ReactNode } from "react";

import { cn } from "@/lib/utils";

type SectionHeaderProps = {
  eyebrow: string;
  title: ReactNode;
  description?: ReactNode;
  centered?: boolean;
  className?: string;
  titleClassName?: string;
  descriptionClassName?: string;
} & Omit<HTMLMotionProps<"div">, "title">;

const SectionHeader = ({
  eyebrow,
  title,
  description,
  centered = false,
  className,
  titleClassName,
  descriptionClassName,
  ...props
}: SectionHeaderProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      className={cn("section-header", centered && "section-header-center", className)}
      {...props}
    >
      <div className={cn("section-line", centered && "section-line-center")} />
      <span className="section-kicker">{eyebrow}</span>
      <h2 className={cn("section-title", titleClassName)}>{title}</h2>
      {description ? (
        <p className={cn("section-copy", descriptionClassName)}>{description}</p>
      ) : null}
    </motion.div>
  );
};

export default SectionHeader;
